import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  .tipo-filtro-wrapper {
    width: 100%;
    z-index: 9;
  }

  .seletor-wrapper {
    margin-right: 10px;
  }

  .input-search-wrapper {
    height: 40px;
  }
`;
